var render, staticRenderFns
import script from "./InnerColorPicker.vue?vue&type=script&lang=js"
export * from "./InnerColorPicker.vue?vue&type=script&lang=js"
import style0 from "./InnerColorPicker.vue?vue&type=style&index=0&id=48803926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48803926",
  null
  
)

export default component.exports